/**
 * Composant global pour gérer le toast hors connexion
 * Monté une seule fois au niveau racine de l'application
 * Le toast est géré automatiquement par le Context
 */
const OfflineToastHandler = () => {
  // Ce composant ne fait rien - la logique est dans OfflineToastProvider
  // Il est présent uniquement pour la clarté de l'architecture
  return null;
};

export default OfflineToastHandler;





